<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Name</label>
          <vs-input
            autocomplete="off"
            v-validate="'required'"
            name="Name"
            v-model="formData.name"
            class="w-full"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <div class="pt-4 pb-6">
          <label>Description</label>
          <vs-textarea v-model="formData.description" class="w-full" />
        </div>

        <img
          v-bind:src="formData.uploadedFileName"
          v-show="formData.uploadedFileName"
          @click="showUpload"
          width="100%"
          class="cursor-pointer"
        />
        <!-- <vs-upload @on-success="successUpload" automatic :action="uploadLocation" text="Upload Image" class="img-upload" ref="fileUpload" accept="image/png,image/gif,image/jpeg" v-show="!formData.uploadedFileName" /> -->
        <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4">
          <v-uploader
            @done="successUpload"
            v-show="!formData.uploadedFileName"
            ref="fileUpload"
            file-type-exts="jpeg,jpg,gif,png"
            button-text="Upload Image"
            language="en"
            file-size-limit="100MB"
            :preview="false"
          ></v-uploader>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button
        class="mr-4 vs-con-loading__container cursor-pointer"
        color="success"
        @click="updateApproach"
        :disabled="isDisabled"
        ref="addupdateButton"
      >{{buttoncaption}}</vs-button>
      <vs-button
        color="danger"
        class="mr-4 vs-con-loading__container cursor-pointer"
        v-show="formData.id"
        @click="deleteBackground"
        ref="deleteButton"
      >Delete</vs-button>
      <vs-button
        type="border"
        class="ml-4 cursor-pointer"
        color="warning"
        @click="isSidebarActiveLocal = false"
      >Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedBackground: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading: "#fff",
      isLoading: false,
      formData: {
        id: 0,
        name: "",
        description: "",
        uploadedFileName: "",
        isUsed: false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function() {
      return !this.formData.uploadedFileName;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if (val) {
        if (this.selectedBackground.id) {
          this.formData.id = this.selectedBackground.id;
          this.formData.name = this.selectedBackground.name;
          this.formData.description = this.selectedBackground.description;
          this.formData.uploadedFileName = this.selectedBackground.imageUrl;
          this.formData.isUsed = this.selectedBackground.isUsed;
        } else {
          this.initValues();
        }
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.uploadedFileName = "";
      this.isLoading = false;
      this.errors.clear();
    },
    successUpload(data) {
      this.formData.uploadedFileName = data[0].url;
      this.$vs.loading.close(this.$refs.fileUpload.$el);
      this.isLoading = false;
    },
    saveData() {
      this.$emit("saveData");
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditBackground() {
      if (!this.formData.uploadedFileName) {
        this.$vs.notify({
          title: "Attention",
          color: "danger",
          text: "Please upload a file.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-upload"
        });
        return;
      }

      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          if (self.formData.isUsed) self.showLoadingOnList();

          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Background Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function() {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };

          self.$ajaxPost(
            self,
            "background",
            self.formData,
            onSuccess,
            onFinally
          );
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    showUpload() {
      this.formData.uploadedFileName = null;
    },
    deleteBackground() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Background Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash"
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(
        self,
        "background/" + self.formData.id,
        onSuccess,
        onFinally
      );
    },
    showLoadingOnButton() {
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton() {
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList() {
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnUploader() {
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    updateApproach() {
      if (this.formData.isUsed && this.formData.id) this.openConfirm();
      else this.addEditBackground();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Attention`,
        text: "The selected background image is being used in one or more scene(s).\n\nAre you sure you want to update it?",
        accept: this.addEditBackground,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      });
    }
  },
  mounted() {
    var self = this;
    self.$refs.fileUpload.$el.addEventListener("click", function() {
      if (!self.isLoading) self.showLoadingOnUploader();
      else {
        self.isLoading = false;
        self.$vs.loading.close(self.$refs.fileUpload.$el);
      }
    });
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>




<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload {
      margin-top: 2rem;
      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
